/*
 * Quick view pop-up (Shop by Color)
 * Opens from product cards ([data-mpqv-open]) and lets customers pick
 * colour (square variant-image swatches) and size, then add to cart
 * without leaving the collection page.
 */
(function () {
  'use strict';

  if (window.MPQV_LOADED) return;
  window.MPQV_LOADED = true;

  var config = window.MPQV_CONFIG || {};
  var S = Object.assign({
    addToCart: 'Dodaj do koszyka',
    selectSize: 'Wybierz rozmiar',
    selectOption: 'Wybierz',
    soldOut: 'Wyprzedane',
    unavailable: 'Niedostępne',
    added: 'Dodano do koszyka',
    continueShopping: 'Kontynuuj zakupy',
    goToCart: 'Przejdź do koszyka',
    details: 'Zobacz szczegóły produktu',
    save: 'Oszczędzasz',
    close: 'Zamknij',
    error: 'Coś poszło nie tak. Spróbuj ponownie.',
    loading: 'Ładowanie…'
  }, config.strings || {});

  var COLOR_NAMES = (config.colorOptionNames || ['kolor', 'kolory', 'color', 'colour', 'wybierz kolor', 'barwa'])
    .map(function (n) { return String(n).trim().toLowerCase(); });

  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || root + 'cart';

  var cache = {};
  var els = null;
  var state = null;
  var lastFocus = null;
  var cartCount = null;
  var openToken = 0;      // increases on every open/close, so late responses are ignored
  var closeTimer = null;  // pending hide after the close animation

  /* ---------- bundle tiers (stapelkorting) ---------- */

  // Configured in the theme editor (sections/mp-bundle-tiers.liquid -> window.MPQV_TIERS)
  function getTiers() {
    var cfg = window.MPQV_TIERS;
    if (!cfg || cfg.enabled === false || !Array.isArray(cfg.tiers) || !cfg.tiers.length) return null;
    var tiers = cfg.tiers
      .map(function (t) { return { quantity: parseInt(t.quantity, 10), percent: parseFloat(t.percent) }; })
      .filter(function (t) { return t.quantity > 0 && t.percent > 0; })
      .sort(function (a, b) { return a.quantity - b.quantity; });
    return tiers.length ? { heading: cfg.heading || '', tiers: tiers } : null;
  }

  // Polish plural for "produkt": 1 produkt, 2–4 produkty (not 12–14), otherwise produktów
  function produkt(n) {
    if (n === 1) return 'produkt';
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'produkty';
    return 'produktów';
  }

  function num(p) {
    return (Math.round(p * 10) / 10).toString().replace('.', ',') + '%';
  }

  function pct(p) {
    return '−' + num(p);
  }

  function tierStatus(count) {
    var cfg = getTiers();
    if (!cfg) return null;
    var current = null;
    var next = null;
    cfg.tiers.forEach(function (t) {
      if (t.quantity <= count) current = t;
      else if (!next) next = t;
    });
    return { cfg: cfg, current: current, next: next, need: next ? next.quantity - count : 0 };
  }

  function tierMessage(count) {
    var s = tierStatus(count);
    if (!s) return '';
    if (!s.next) {
      return 'Masz najwyższy rabat: ' + num(s.current.percent) + '!';
    }
    if (count <= 0) {
      return 'Kup ' + s.next.quantity + ' ' + produkt(s.next.quantity) + ' i oszczędź ' + num(s.next.percent) + '.';
    }
    return 'Masz ' + count + ' ' + produkt(count) + ' w koszyku – dodaj jeszcze ' + s.need + ' ' + produkt(s.need) +
      ' i zyskaj ' + num(s.next.percent) + ' rabatu.';
  }

  function renderTiers() {
    if (!els || !state) return;
    var box = els.body.querySelector('[data-mpqv-tiers]');
    if (!box) return;
    var count = cartCount == null ? 0 : cartCount;
    var s = tierStatus(count);
    if (!s) {
      box.hidden = true;
      return;
    }

    var html = '';
    if (s.cfg.heading) html += '<p class="mpqv__tiers-heading">' + esc(s.cfg.heading) + '</p>';
    html += '<ul class="mpqv__tiers-list" role="list">';
    s.cfg.tiers.forEach(function (t) {
      var cls = 'mpqv__tier';
      if (s.current && t.quantity <= s.current.quantity) cls += ' is-reached';
      if (s.next && t.quantity === s.next.quantity) cls += ' is-next';
      html += '<li class="' + cls + '">' +
        '<span class="mpqv__tier-qty">' + t.quantity + '+ szt.</span>' +
        '<span class="mpqv__tier-pct">' + esc(pct(t.percent)) + '</span>' +
        '</li>';
    });
    html += '</ul>';
    if (cartCount != null) {
      html += '<p class="mpqv__tiers-msg">' + esc(tierMessage(count)) + '</p>';
    }
    box.innerHTML = html;
    box.hidden = false;
  }

  function loadCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartCount = cart.item_count || 0;
        return cart;
      });
  }

  /* ---------- helpers ---------- */

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function sizedUrl(src, width) {
    if (!src) return '';
    var url = String(src);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || (window.theme && window.theme.moneyFormat) || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', '');
        default: return withDelimiters(cents, 2);
      }
    });
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Product request failed: ' + res.status);
        return res.json();
      })
      .then(function (product) {
        cache[handle] = product;
        return product;
      });
  }

  /* ---------- modal shell ---------- */

  function build() {
    if (els) return els;
    var wrap = document.createElement('div');
    wrap.className = 'mpqv';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="mpqv__overlay" data-mpqv-close></div>' +
      '<div class="mpqv__dialog" role="dialog" aria-modal="true" aria-labelledby="MpqvTitle" tabindex="-1">' +
        '<button type="button" class="mpqv__close" data-mpqv-close aria-label="' + esc(S.close) + '">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="mpqv__body" data-mpqv-body></div>' +
      '</div>';
    document.body.appendChild(wrap);

    wrap.addEventListener('click', function (event) {
      if (event.target.closest('[data-mpqv-close]')) {
        event.preventDefault();
        close();
      }
    });

    els = {
      wrap: wrap,
      dialog: wrap.querySelector('.mpqv__dialog'),
      body: wrap.querySelector('[data-mpqv-body]')
    };
    return els;
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('mpqv-lock', lock);
  }

  function open(handle, preferredVariantId, opener) {
    build();
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    var token = ++openToken;
    state = null;
    lastFocus = opener || document.activeElement;
    els.body.innerHTML = '<div class="mpqv__loading" aria-live="polite"><span class="mpqv__spinner"></span><span class="visually-hidden">' + esc(S.loading) + '</span></div>';
    els.wrap.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () { els.wrap.classList.add('is-open'); });
    lockScroll(true);
    els.dialog.focus({ preventScroll: true });

    if (getTiers()) {
      loadCartCount()
        .then(function () { if (token === openToken) renderTiers(); })
        .catch(function () { /* ignore */ });
    }

    fetchProduct(handle)
      .then(function (product) {
        // ignore responses for a pop-up that was closed or replaced meanwhile
        if (token !== openToken) return;
        render(product, preferredVariantId);
      })
      .catch(function () {
        if (token !== openToken) return;
        // fall back to the product page if anything goes wrong
        window.location.href = root + 'products/' + encodeURIComponent(handle);
      });
  }

  function close() {
    if (!els || els.wrap.hidden) return;
    openToken++;
    els.wrap.classList.remove('is-open');
    lockScroll(false);
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeTimer = null;
      els.wrap.hidden = true;
      els.body.innerHTML = '';
      state = null;
    }, 250);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  /* ---------- product model ---------- */

  function colorIndexOf(product) {
    var names = product.options || [];
    for (var i = 0; i < names.length; i++) {
      var name = (typeof names[i] === 'string' ? names[i] : names[i].name) || '';
      if (COLOR_NAMES.indexOf(name.trim().toLowerCase()) > -1) return i;
    }
    return -1;
  }

  function optionName(product, i) {
    var opt = (product.options || [])[i];
    return typeof opt === 'string' ? opt : (opt && opt.name) || '';
  }

  function optionValues(product, i) {
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v.options[i];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  // images for one colour: from that colour's variant image up to the next variant image
  function imagesForColor(product, colorIndex, colorValue) {
    var images = product.images || [];
    if (!images.length) return [];
    if (colorIndex < 0) return images.slice(0, 6);

    var starts = [];
    product.variants.forEach(function (v) {
      if (v.featured_image && v.featured_image.position && starts.indexOf(v.featured_image.position) === -1) {
        starts.push(v.featured_image.position);
      }
    });
    starts.sort(function (a, b) { return a - b; });

    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].options[colorIndex] === colorValue && product.variants[i].featured_image) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return images.slice(0, 1);

    var start = variant.featured_image.position;
    var next = images.length + 1;
    for (var j = 0; j < starts.length; j++) {
      if (starts[j] > start) { next = starts[j]; break; }
    }
    return images.slice(start - 1, Math.min(next - 1, start - 1 + 6));
  }

  // no variant image -> '' so the swatch shows the colour name instead of a repeated photo
  function swatchImage(product, colorIndex, colorValue) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[colorIndex] === colorValue && v.featured_image) return v.featured_image.src;
    }
    return '';
  }

  function findVariant(product, selected) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var k = 0; k < selected.length; k++) {
        if (selected[k] == null || v.options[k] !== selected[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // is there an available variant for value `val` at option `index`, given the selections
  // of the options shown before it (colour first, so sizes reflect the chosen colour)?
  function isAvailable(product, selected, index, val) {
    var order = (state && state.order) || [];
    var before = order.slice(0, Math.max(order.indexOf(index), 0));
    return product.variants.some(function (v) {
      if (v.options[index] !== val || !v.available) return false;
      for (var k = 0; k < before.length; k++) {
        var o = before[k];
        if (selected[o] != null && v.options[o] !== selected[o]) return false;
      }
      return true;
    });
  }

  /* ---------- render ---------- */

  function render(product, preferredVariantId) {
    var colorIndex = colorIndexOf(product);
    var count = (product.options || []).length;
    var preferred = null;
    product.variants.forEach(function (v) {
      if (String(v.id) === String(preferredVariantId)) preferred = v;
    });
    if (!preferred) {
      preferred = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    }

    // option order: colour first, then the rest
    var order = [];
    if (colorIndex > -1) order.push(colorIndex);
    for (var i = 0; i < count; i++) if (i !== colorIndex) order.push(i);

    var selected = [];
    for (var s = 0; s < count; s++) selected.push(null);
    order.forEach(function (idx) {
      var values = optionValues(product, idx);
      // colour (or the only option) starts on the card's variant; other options start unselected unless there is only one value
      if (idx === colorIndex || values.length === 1 || product.has_only_default_variant) {
        selected[idx] = preferred.options[idx];
      }
    });

    state = {
      product: product,
      colorIndex: colorIndex,
      order: order,
      selected: selected,
      imageIndex: 0,
      adding: false
    };

    var url = product.url || (root + 'products/' + product.handle);

    els.body.innerHTML =
      '<div class="mpqv__grid">' +
        '<div class="mpqv__media">' +
          '<div class="mpqv__main" data-mpqv-main></div>' +
          '<div class="mpqv__thumbs" data-mpqv-thumbs></div>' +
        '</div>' +
        '<div class="mpqv__info">' +
          '<div class="mpqv__scroll">' +
            '<h2 class="mpqv__title" id="MpqvTitle"><a href="' + esc(url) + '" data-mpqv-link>' + esc(product.title) + '</a></h2>' +
            '<div class="mpqv__price" data-mpqv-price></div>' +
            '<div class="mpqv__options" data-mpqv-options></div>' +
            '<div class="mpqv__tiers" data-mpqv-tiers hidden></div>' +
          '</div>' +
          '<div class="mpqv__footer" data-mpqv-footer>' +
            '<button type="button" class="mpqv__add" data-mpqv-add></button>' +
            '<p class="mpqv__error" data-mpqv-error role="alert" hidden></p>' +
            '<a class="mpqv__details" href="' + esc(url) + '" data-mpqv-link>' + esc(S.details) + '</a>' +
          '</div>' +
          '<div class="mpqv__success" data-mpqv-success hidden></div>' +
        '</div>' +
      '</div>';

    els.body.querySelector('[data-mpqv-add]').addEventListener('click', add);
    update();
    renderTiers();
  }

  function renderOptions() {
    var p = state.product;
    var html = '';

    state.order.forEach(function (idx) {
      var values = optionValues(p, idx);
      if (p.has_only_default_variant) return;
      var name = optionName(p, idx);
      var current = state.selected[idx];
      var isColor = idx === state.colorIndex;

      html += '<fieldset class="mpqv__option' + (isColor ? ' mpqv__option--color' : '') + '">' +
        '<legend class="mpqv__option-head"><span class="mpqv__option-name">' + esc(name) + ':</span> ' +
        '<span class="mpqv__option-value">' + esc(current || '') + '</span></legend>' +
        '<div class="mpqv__values">';

      values.forEach(function (val) {
        var available = isAvailable(p, state.selected, idx, val);
        var active = current === val;
        var cls = 'mpqv__value' + (isColor ? ' mpqv__value--swatch' : ' mpqv__value--text') +
          (active ? ' is-active' : '') + (available ? '' : ' is-unavailable');

        if (isColor) {
          var img = swatchImage(p, idx, val);
          html += '<button type="button" class="' + cls + '" data-mpqv-value data-index="' + idx + '" data-value="' + esc(val) + '"' +
            ' aria-pressed="' + active + '" aria-label="' + esc(val) + (available ? '' : ' – ' + esc(S.soldOut)) + '" title="' + esc(val) + '">' +
            (img ? '<img src="' + esc(sizedUrl(img, 160)) + '" alt="" loading="lazy" width="64" height="80">' : '<span>' + esc(val) + '</span>') +
            '</button>';
        } else {
          html += '<button type="button" class="' + cls + '" data-mpqv-value data-index="' + idx + '" data-value="' + esc(val) + '"' +
            ' aria-pressed="' + active + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' +
            esc(val) + '</button>';
        }
      });

      html += '</div></fieldset>';
    });

    var box = els.body.querySelector('[data-mpqv-options]');
    box.innerHTML = html;
    box.querySelectorAll('[data-mpqv-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        var val = btn.getAttribute('data-value');
        state.selected[idx] = val;

        if (idx === state.colorIndex) {
          state.imageIndex = 0;
          // keep the chosen size if it still exists and is available in the new colour; otherwise clear it
          state.order.forEach(function (other) {
            if (other === idx || state.selected[other] == null) return;
            if (!isAvailable(state.product, state.selected, other, state.selected[other]) &&
                optionValues(state.product, other).length > 1) {
              state.selected[other] = null;
            }
          });
        }
        hideError();
        update();
      });
    });
  }

  function renderMedia() {
    var p = state.product;
    var colorValue = state.colorIndex > -1 ? state.selected[state.colorIndex] : null;
    var images = imagesForColor(p, state.colorIndex, colorValue);
    if (!images.length && p.featured_image) images = [p.featured_image];
    if (state.imageIndex >= images.length) state.imageIndex = 0;

    var main = els.body.querySelector('[data-mpqv-main]');
    var src = images[state.imageIndex];
    main.innerHTML = src
      ? '<img src="' + esc(sizedUrl(src, 900)) + '" srcset="' + esc(sizedUrl(src, 600)) + ' 600w, ' + esc(sizedUrl(src, 900)) + ' 900w, ' + esc(sizedUrl(src, 1200)) + ' 1200w" sizes="(min-width: 750px) 440px, 100vw" alt="' + esc(p.title + (colorValue ? ' – ' + colorValue : '')) + '">'
      : '';

    var thumbs = els.body.querySelector('[data-mpqv-thumbs]');
    if (images.length > 1) {
      thumbs.innerHTML = images.map(function (img, i) {
        return '<button type="button" class="mpqv__thumb' + (i === state.imageIndex ? ' is-active' : '') + '" data-mpqv-thumb="' + i + '" aria-label="' + (i + 1) + '/' + images.length + '">' +
          '<img src="' + esc(sizedUrl(img, 160)) + '" alt="" loading="lazy" width="56" height="70"></button>';
      }).join('');
      thumbs.hidden = false;
      thumbs.querySelectorAll('[data-mpqv-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.imageIndex = parseInt(btn.getAttribute('data-mpqv-thumb'), 10);
          renderMedia();
        });
      });
    } else {
      thumbs.innerHTML = '';
      thumbs.hidden = true;
    }
  }

  function currentVariant() {
    return findVariant(state.product, state.selected);
  }

  // variant used for price/link when the selection is not complete yet
  function displayVariant() {
    var full = currentVariant();
    if (full) return full;
    var p = state.product;
    var ci = state.colorIndex;
    var candidates = p.variants.filter(function (v) {
      return ci < 0 || v.options[ci] === state.selected[ci];
    });
    var available = candidates.filter(function (v) { return v.available; });
    var pool = available.length ? available : candidates;
    return pool.sort(function (a, b) { return a.price - b.price; })[0] || p.variants[0];
  }

  function renderPrice() {
    var v = displayVariant();
    var box = els.body.querySelector('[data-mpqv-price]');
    var html = '<span class="mpqv__price-now' + (v.compare_at_price > v.price ? ' is-sale' : '') + '">' + esc(formatMoney(v.price)) + '</span>';
    if (v.compare_at_price > v.price) {
      html += '<s class="mpqv__price-was">' + esc(formatMoney(v.compare_at_price)) + '</s>';
      // same as the product page badge: "-190 zł" (minus sign, no trailing zeros)
      html += '<span class="mpqv__badge">-' + esc(formatMoney(v.compare_at_price - v.price).replace(/[.,]00(?!\d)/, '')) + '</span>';
    }
    box.innerHTML = html;
  }

  function renderButton() {
    var btn = els.body.querySelector('[data-mpqv-add]');
    var v = currentVariant();
    var missing = null;
    state.order.forEach(function (idx) {
      if (missing == null && state.selected[idx] == null) missing = idx;
    });

    if (missing != null) {
      var name = optionName(state.product, missing).toLowerCase();
      var label = /rozmiar|size/.test(name) ? S.selectSize : S.selectOption + ' ' + name;
      btn.textContent = label;
      btn.disabled = true;
      btn.classList.add('is-waiting');
    } else if (!v || !v.available) {
      btn.textContent = v ? S.soldOut : S.unavailable;
      btn.disabled = true;
      btn.classList.remove('is-waiting');
    } else {
      btn.textContent = S.addToCart;
      btn.disabled = state.adding;
      btn.classList.remove('is-waiting');
    }

    // keep links pointing at the chosen colour/variant
    var linkVariant = v || displayVariant();
    var base = state.product.url || (root + 'products/' + state.product.handle);
    els.body.querySelectorAll('[data-mpqv-link]').forEach(function (a) {
      a.setAttribute('href', base + (linkVariant ? '?variant=' + linkVariant.id : ''));
    });
  }

  function update() {
    renderOptions();
    renderMedia();
    renderPrice();
    renderButton();
  }

  function showError(msg) {
    var el = els.body.querySelector('[data-mpqv-error]');
    if (!el) return;
    el.textContent = msg || S.error;
    el.hidden = false;
  }

  function hideError() {
    var el = els && els.body.querySelector('[data-mpqv-error]');
    if (el) el.hidden = true;
  }

  /* ---------- cart ---------- */

  function add() {
    if (!state) return;
    var v = currentVariant();
    if (!v || !v.available || state.adding) return;
    var st = state;          // the pop-up this add belongs to
    st.adding = true;
    var btn = els.body.querySelector('[data-mpqv-add]');
    btn.disabled = true;
    btn.classList.add('is-loading');
    hideError();

    // still showing the same pop-up?
    function current() {
      return state === st && els && !els.wrap.hidden;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json()
          .catch(function () {
            // non-JSON reply (e.g. an HTML error page): never show raw parser text to customers
            var e = new Error(S.error);
            e.safe = true;
            throw e;
          })
          .then(function (data) {
            if (!res.ok || data.status) {
              // Shopify cart errors carry a customer-friendly description (e.g. stock limits)
              var e = new Error(data.description || S.error);
              e.safe = true;
              throw e;
            }
            return data;
          });
      })
      .then(function () {
        st.adding = false;
        // the item is in the cart: always refresh cart state, even if the pop-up was closed meanwhile
        refreshCart();
        if (!current()) return;
        btn.classList.remove('is-loading');

        // A cart drawer app is present (Upcart / Essential Cart Drawer): close the pop-up
        // and let the drawer take over, so the customer never sees two layers on top of each other.
        var openDrawer = cartDrawerOpener();
        if (openDrawer) {
          close();
          setTimeout(function () {
            try { openDrawer(); } catch (e) { /* ignore */ }
          }, 260);
          return;
        }

        // no Upcart (fallback): confirmation inside the pop-up
        showSuccess(v);
      })
      .catch(function (err) {
        st.adding = false;
        if (!current()) return;
        btn.classList.remove('is-loading');
        renderButton();
        showError(err && err.safe ? err.message : S.error);
      });
  }

  function showSuccess(variant) {
    var footer = els.body.querySelector('[data-mpqv-footer]');
    var box = els.body.querySelector('[data-mpqv-success]');
    var title = variant.public_title || variant.title || '';
    box.innerHTML =
      '<p class="mpqv__success-title">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span>' + esc(S.added) + '</span>' +
      '</p>' +
      (title && title !== 'Default Title' ? '<p class="mpqv__success-variant">' + esc(title) + '</p>' : '') +
      '<p class="mpqv__success-tier" data-mpqv-success-tier hidden></p>' +
      '<div class="mpqv__success-actions">' +
        '<button type="button" class="mpqv__btn mpqv__btn--primary" data-mpqv-close>' + esc(S.continueShopping) + '</button>' +
        '<a class="mpqv__btn mpqv__btn--secondary" href="' + esc(cartUrl) + '" data-mpqv-cart>' + esc(S.goToCart) + '</a>' +
      '</div>';
    footer.hidden = true;
    box.hidden = false;

    var cartLink = box.querySelector('[data-mpqv-cart]');
    cartLink.addEventListener('click', function (event) {
      var openDrawer = cartDrawerOpener();
      if (openDrawer) {
        event.preventDefault();
        close();
        setTimeout(function () { openDrawer(); }, 260);
      }
    });
    var cont = box.querySelector('[data-mpqv-close]');
    if (cont) cont.focus({ preventScroll: true });
  }

  // after adding: celebrate a reached tier and point to the next one
  function renderSuccessTier() {
    if (!els) return;
    var el = els.body.querySelector('[data-mpqv-success-tier]');
    if (!el || cartCount == null) return;
    var s = tierStatus(cartCount);
    if (!s) return;
    var parts = [];
    if (s.current && s.next) {
      parts.push('Rabat ' + num(s.current.percent) + ' jest aktywny.');
      parts.push('Dodaj jeszcze ' + s.need + ' ' + produkt(s.need) + ', aby otrzymać ' + num(s.next.percent) + ' rabatu.');
    } else if (s.current) {
      parts.push('Masz najwyższy rabat: ' + num(s.current.percent) + '!');
    } else if (s.next) {
      parts.push('Dodaj jeszcze ' + s.need + ' ' + produkt(s.need) + ' i zyskaj ' + num(s.next.percent) + ' rabatu.');
    }
    el.textContent = parts.join(' ');
    el.hidden = !parts.length;
  }

  // Cart drawer apps used on our stores: Upcart (Moda Poznan), Essential Cart Drawer (Lorenzari).
  // Returns a function that opens the app's drawer, or null when no drawer app is loaded.
  function cartDrawerOpener() {
    if (typeof window.upcartOpenCart === 'function') {
      return function () { window.upcartOpenCart(); };
    }
    var ess = window.essentialCartApi;
    if (ess && typeof ess.openCart === 'function') {
      return function () { ess.openCart(); };
    }
    return null;
  }

  function refreshCart() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    } catch (e) { /* ignore */ }

    // Broadcast's header counter listens to theme:cart:change ({ cartCount }).
    // theme:product:added is deliberately NOT sent: it would open a cart drawer,
    // and the customer should be able to keep shopping.
    var hooks = config.cartEvents || ['theme:cart:change'];
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartCount = cart.item_count || 0;
        renderTiers();
        renderSuccessTier();
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        hooks.forEach(function (name) {
          try {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cartCount: cart.item_count, cart: cart } }));
          } catch (e) { /* ignore */ }
        });
      })
      .catch(function () { /* ignore */ });
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mpqv-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    open(trigger.getAttribute('data-handle'), trigger.getAttribute('data-variant'), trigger);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!els || els.wrap.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key === 'Tab') {
      // only visible elements (the footer is hidden after "added to cart")
      var focusables = Array.prototype.filter.call(
        els.dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el.getClientRects().length > 0; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  window.MPQV = { open: open, close: close };
})();
